import { isEmpty, negate, map } from 'lodash';
import React from 'react';

const startCase = value =>
  value
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

/**
 * Get the first value in the input array that is not empty.
 * @param values array of values to look in.
 * @returns {undefined|*}
 */
const getPreferredValueOf = (values) => {
  const cleanValues = values.filter(negate(isEmpty));
  if (!isEmpty(cleanValues)) {
    return cleanValues[0];
  }
  return undefined;
};

const getCoreLogicOrderedParts = (address) => {
  let level;
  if (address.levelType && address.levelNr) {
    level = `${address.levelType} ${address.levelNr}`;
  }
  let addressLine1 = address.addressLine1;
  if (level) {
    addressLine1 = `${level}, ${address.addressLine1}`;
  }
  let region = getPreferredValueOf([address.terrAuthName, address.locality]);
  if (address.addressLine4 && address.addressLine4.toLowerCase().indexOf(region.toLowerCase()) > -1) {
    region = undefined;
  }
  return [
    addressLine1,
    address.addressLine2,
    address.addressLine3,
    address.addressLine4,
    region
  ];
};

const getLines = (address) => {
  let orderedParts;
  if (address.addressLine1) {
    orderedParts = getCoreLogicOrderedParts(address);
    orderedParts = orderedParts.filter(negate(isEmpty));
    orderedParts = orderedParts.map(startCase);
  } else {
    const building = address.building || address.buildingName;
    orderedParts = [building, address.street, address.suburb, address.city];
    if (address.streetName) {
      orderedParts = [building, address.streetName, address.suburb, address.city];
    }

    orderedParts = orderedParts.filter(negate(isEmpty));
    orderedParts = orderedParts.map(startCase);
    if (building) {
      orderedParts.splice(0, 1, building.toUpperCase());
    }
    if (orderedParts.length === 4) {
      orderedParts = [`${orderedParts[0]}, ${orderedParts[1]}`, orderedParts[2], orderedParts[3]];
    }
  }
  return orderedParts;
};

const buildMultiLine = (address) => {
  const lines = getLines(address);
  return (
    <div>
      {
        map(lines, (value, index) =>
          (<div key={`address-line-${index}`} id={`address-line-${index}`}>{value}</div>))
      }
    </div>
  );
};

const build = (address) => {
  const orderedParts = getLines(address);
  return orderedParts.join(', ');
};

const FullAddressBuilder = {
  getLines,
  buildMultiLine,
  build
};

export default FullAddressBuilder;



/** WEBPACK FOOTER **
 ** ./src/common/FullAddressBuilder.js
 **/